


<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>








<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>




<div  class="row">
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">White-Collar Verification</span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Experience a customizable delight in your white-collar background screening process and empower your verification journey.</h5>
    </div>

    <div class="col-md-6 text-center">
        <img style="width:70%;height: auto;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/whitecollarimage.png">
    </div>
</div>
<br><br>
<br>

<br><br><br>
<div class="row"  data-aos="zoom-in" data-aos-delay="300">
    <div class="col">

        <h2 style="text-align: center;color: #6ab187;">Solve Your White Collar Employee<br> Onboarding & Verification<br> Challenges</h2><br>
        <p style="text-align:center;">Propel your screening decisions with a seamless fusion of data, cutting-edge technology,<br> and expertise.</p>
    </div>
</div>

<br><br>

<div class="row p-3 text-center"  data-aos="fade-up" data-aos-delay="300" >

    <div  class="col-md-4 mt-2">
        <div class="card" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/turnaround.jpg">
                <br><br>
              <h5 class="card-title">Reduce Turnaround Time</h5>
              <p class="card-text">Fast and accurate white collar employee screening process to ensure comprehensive verification outcomes within record time.<br></p>
            </div>            
          </div>
    </div>

    <div class="col-md-4 mt-2">

        <div class="card" >
            <div class="card-body">
                <img style="width: 20%;height:20%" src="assets/enhanceaccuracy.png"><br>
           <br>
              <h5 class="card-title">Enhance Check Accuracy</h5>
              <p class="card-text">Leverage our expansive proprietary database and advanced analytics to get accurate and reliable verification results you can trust.</p>
            </div>            
          </div>
    </div>

    <div class="col-md-4 mt-2">
        <div class="card" >
            <div class="card-body">
                <img style="width: 20%;height:20%" src="assets/limitlessstable.jpg">
                <br><br>
              <h5 class="card-title">Get Limitless Scalability</h5>
              <p class="card-text">Effortlessly handle verifications at any scale, no matter how large or complex your hiring & screening needs may be</p>
            </div>            
          </div>
    </div>


  </div>
  <br><br>


  <div class="row"  data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
        <h2 style="color: #6ab187;text-align: center;">Process of White Collar Verification</h2><br>
        <h1 style="text-align: center;">Customize White-collar Employee <br>Verification in 4 Easy Steps</h1><br>
        <p style="text-align: center;">Create a customized background verification process tailored to your unique needs.</p>
     
    </div>
  </div>


  <div  class="row p-3"  data-aos="fade-up" data-aos-delay="300"   >

    <div   class="col-md-3">
        <br>
        <img style="width: 60px;height: 65px;" src="assets/verifyrequire.png">
       <br><br><br>
        <h5>STEP 1</h5>
        <p style="align-items: center;">Share your verification requirements with us.</p>
    </div>
  
    <div class="col-md-3">
          <br>
          <img style="width: 80px;height: 80px;" src="assets/customizedcheck.jpg">
         <br><br>
          <h5>STEP 2</h5>
          <p style="align-items: center;">Define the scope with customized checks for every stage.</p>
      </div>
     
      <div class="col-md-3">
     
        <br>
        <img style="width: 80px;height: 80px;" src="assets/riskmanage.jpg">
       <br><br>
        <h5 >STEP 3</h5>
        <p style="align-items: center;">Define risk matrix based on employee type and nature of business<p>
    </div>

    <div class="col-md-3">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/businessrequire.jpg">
       <br><br><br>
        <h5 >STEP 4</h5>
        <p style="align-items: center;">We recommend the list of verification checks based on business requirements<p>
    </div>
  
  </div>

<br><br><br>

<div class="row"   data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h4 style="color: #6ab187;text-align: center;">Facheck's White Collar Employee Verification</h4>
        <h2 style="text-align: center;">Revolutionize Your White-collar Verification<br> Process</h2>
        <p style="text-align: center;">Elevate your white collar employee background verification process with unmatched accuracy & limitless scalability.</p>
        <br><br><br>
    </div>
</div>


<div class="row p-2"  data-aos="fade-up" data-aos-delay="300">
    <div class="col-md-6">
        <br>
        <img style="width: 37px;height: 37px;" src="assets/backgroundverifyimage.png">
        <span style="margin-left: 20px;color: #6ab187;">Background Verification</span><br><br>
        <h3 style="text-align: start;color: #6ab187;">Complete White-collar Verifications Faster</h3>
        <p >We understand the urgency to onboard top talent promptly. Our platform is engineered for speed and efficiency, ensuring you receive comprehensive results within industry-leading turnaround times. By leveraging our extensive resources and advanced technology, you can expedite your onboarding & screening process without compromising on quality or accuracy.</p>
    </div>

    <div class="col-md-6 text-center">
        <img style="width: 80%;height: 100%;" src="assets/backgroundverify.png">
    </div>
</div>

<br><br><br><br>


<div class="row p-2"  data-aos="fade-up" data-aos-delay="300">
 
    <div class="col-md-6 text-center">
        <img style="width: 80%;height: 100%;margin-right: 20px;" src="assets/customersupportimage.png">
    </div>

    <div class="col-md-6">
        <br>
        <img style="width: 37px;height: 37px;" src="assets/customersupport.png">
        <span style="color: #6ab187;">Customer Support</span><br><br>
        <h3 style="text-align: start;color: #6ab187;">Ensure Peace of Mind with Unmatched Support</h3>
        <p>We are with you every step of the way. Dedicated helplines and customer support for both the employees as well as the business. Multi-channel customer support to resolve all your requests faster and satisfactorily.</p>
    </div>
</div>
<br><br><br><br>



<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
    <div class="col-md-6">
        <br>
        <img style="width: 37px;height: 37px" src="assets/tailormade.png">
        <span style="margin-left: 20px;color: #6ab187;">Tailor Made</span><br>
        <h3 style="text-align: start;color: #6ab187;">Build Your Own Verification Process with Customizable Workflows</h3>
        <p >Enjoy the the flexibility to customize screening workflows according to your specific requirements. Tailor the workflows to your organization’s needs, add or remove specific components, and establish a smooth, digital onboarding journey without any paperwork.</p>
    </div>

    <div class="col-md-6 text-center">
        <img style="width: 80%;height: 80%;" src="assets/customizedworkflow.png">
    </div>
</div>

<br><br>


<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
 
    <div class="col-md-6 text-center">
        <img style="width: 70%;height: 90%;" src="assets/easyintegrate.jpg">
    </div>

    <div class="col-md-6">
        <br>
        <img style="width: 37px;height: 37px;" src="assets/customersupport.png">
        <span style="color: #6ab187;">Easy Integration</span><br>
        <h3 style="text-align: start;color: #6ab187;">Smooth Operations with Seamless Integrations</h3>
        <p>Seamlessly integrates with industry-leading HRMS solutions (such as Zoho Recruit, Darwinbox, GreytHR, Keka, ZingHR, etc.) and ATS (applicant tracking system), allowing you to optimize your existing infrastructure and streamline your processes. Our open APIs enable smooth integration with leading systems.</p>
    </div>
</div>

<br><br><br><br>

<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
    <div class="col-md-6">
        <br>
        <img style="width: 50px;height: 47px" src="assets/security&compliance.png">
        <span style="margin-left: 20px;color: #6ab187;">Security and Compliance</span><br>
        <h3 style="text-align: start;color: #6ab187;">Elevate Standards with Enterprise-Grade Quality and Security</h3>
        <p >We prioritize quality management and data security and continuously strive for customer satisfaction by delivering exceptional services that meet the highest standards. We ensure compliance with enterprise-grade security regulations to safeguard your information and maintain confidentiality.</p>
    </div>

    <div class="col-md-6 text-center"> 
        <img style="width: 70%;height: 100%;" src="assets/securityimage.png">
    </div>
</div>



<br><br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">50+ Background Verification Checks</h3>
        <p style="text-align: center;">List of verification checks to run background verification for white collar employees</p>
    </div>

</div>
<br><br>

<div  class="row p-3" data-aos="fade-up" data-aos-delay="300">
    <div class="col-md-3 mt-2 text-center">
        <div  class="card" style="height: 160px;">
            <div class="card-body">
                <img style="width: 34%;height:30%" src="assets/educationcheck.png">
                <br><br>
              <h5 class="card-title">Education Check</h5><br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 text-center">
      <div class="card" style="height: 160px;">
          <div class="card-body">
              <img style="width: 34%;height:30%" src="assets/panchecks.png">
           <br><br>
            <h5 class="card-title">PAN Card</h5><br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2 text-center">
    <div class="card" style="height: 160px;">
        <div  class="card-body">

            <img style="width: 30%;height:30%" src="assets/bankaccount.png">
            <br><br>
          <h5 class="card-title">Bank Account</h5>
<br>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2 text-center">
  <div class="card" style="height: 160px;">
      <div class="card-body">
          <img style="width: 34%;height:30%"  src="assets/voteridchecks.png">
          <br><br>
        <h5 class="card-title">Aadhaar Verification</h5>

      </div>            
    </div>
</div>

  </div>
  <br><br>
  <br>

  <div data-aos="fade-up" data-aos-delay="300" class="row p-3">
    <div class="col-md-3 mt-2 text-center">
        <div  class="card" style="height: 160px;">
            <div class="card-body">
                <img style="width: 34%;height:30%" src="assets/employementcheck.png">
                <br><br>
              <h5 class="card-title">Employment Check</h5>

            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 text-center">
        <div  class="card" style="height: 160px;">
            <div class="card-body">
                <img style="width: 34%;height:30%" src="assets/referencecheck.jpg">
                <br><br>
              <h5 class="card-title">Professional reference Check</h5>

            </div>            
          </div>
    </div>

  <div class="col-md-3 mt-2 text-center">
    <div class="card" style="height: 160px;">
        <div  class="card-body">
      <img style="width: 29%;height:29%" src="assets/voterid.jpg">
            <br><br>
          <h5 class="card-title">Voter Id verification</h5>

        </div>            
      </div>
</div>

<div class="col-md-3 mt-2 text-center">
  <div class="card" style="height: 160px;">
      <div class="card-body">
          <img style="width: 34%;height:30%"  src="assets/addressverify.png">
          <br><br>
        <h5 class="card-title">Address Verification check</h5>

      </div>            
    </div>
</div>

  </div>

<br><br>


<br><br><br>



